import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userGroupSelector = ({ userGroup }: ReducerState) => userGroup;
export const userGroupLoadingSelector = createSelector(
  userGroupSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
